import { ACTIVITY_TYPES, ANSWER_VERSION, LANGUAGES_NAME } from "./constants"

export const isFlexContent = (activityTypeId) => {
  return activityTypeId === ACTIVITY_TYPES.CONNECTING_LINES
}

export const isExplanationActivity = (activityTypeId) => {
  return (
    activityTypeId === ACTIVITY_TYPES.EXPLANATION ||
    activityTypeId === ACTIVITY_TYPES.VIDEO_EXPLANATION
  )
}

export const isListenActivity = (activityTypeId) => {
  return (
    activityTypeId === ACTIVITY_TYPES.LISTEN_AND_FIND_THE_PICTURE ||
    activityTypeId === ACTIVITY_TYPES.MATCHING_AUDIOS ||
    activityTypeId === ACTIVITY_TYPES.ORAL_COMPREHENSION_SHORT
  )
}

export const isActivityGradedByTeacher = (activityTypeId) => {
  return (
    activityTypeId === ACTIVITY_TYPES.JUST_WRITE ||
    activityTypeId === ACTIVITY_TYPES.JUST_TALK ||
    activityTypeId === ACTIVITY_TYPES.INTERVIEW ||
    activityTypeId === ACTIVITY_TYPES.COMPARATIVE_ESSAY ||
    activityTypeId === ACTIVITY_TYPES.JUST_WRITE_MULTIPLE ||
    activityTypeId === ACTIVITY_TYPES.JUST_TALK_MULTIPLE ||
    activityTypeId === ACTIVITY_TYPES.ESSAY
  )
}

export const isRandomExerciseActivity = (activityTypeId) => {
  return activityTypeId === ACTIVITY_TYPES.NONE
}

export const isMatchingActivity = (activityTypeId) => {
  return (
    activityTypeId === ACTIVITY_TYPES.LISTEN_AND_CHOOSE ||
    activityTypeId === ACTIVITY_TYPES.FIND_THE_PICTURE ||
    activityTypeId === ACTIVITY_TYPES.LISTEN_AND_FIND_THE_PICTURE ||
    activityTypeId === ACTIVITY_TYPES.MATCHING_PICTURES ||
    activityTypeId === ACTIVITY_TYPES.FIND_THE_PICTURE_FIXED
  )
}

export const isContentCenter = (activityTypeId) => {
  return (
    activityTypeId === ACTIVITY_TYPES.PICTURE_AND_QUESTION ||
    activityTypeId === ACTIVITY_TYPES.PICTURE_AND_QUESTION_WRITE ||
    activityTypeId === ACTIVITY_TYPES.SOACKED_MAN ||
    activityTypeId === ACTIVITY_TYPES.SCRAMBLED_SENTENCES ||
    activityTypeId === ACTIVITY_TYPES.COMPREHENSION ||
    activityTypeId === ACTIVITY_TYPES.MEMORAMA
  )
}

export const isWordsActivity = (activityTypeId) => {
  return (
    activityTypeId === ACTIVITY_TYPES.WORD_SEARCH ||
    activityTypeId === ACTIVITY_TYPES.CROSSWORD
  )
}

export const hasExplanationActivity = (activities) => {
  return activities.some((activity) =>
    isExplanationActivity(activity.activityTypeId)
  )
}

export const getEmptyAnswer = (status = false) => {
  return [
    {
      contentId: 0,
      answer: "",
      status,
      version: ANSWER_VERSION,
    },
  ]
}

export const parseText = (text) => {
  if (!text) return ""
  return text
    .trim()
    .replace(/œ/g, "oe")
    .replace(/[¡!?¿_;:.,&«»]/g, "")
    .replace(/[’]/g, "'")
    .replace(/[“]/g, '"')
    .replace(/[”]/g, '"')
    .replace(/[‘]/g, "'")
    .replace(/\s+/g, " ") // delete multiple spaces
    .replace(/\u2028/g, "") // delete \u2028 &#x2028; (unicode character)
    .replace(/\u2026/g, "...") // replace \u2026 &#x2026; (unicode character)
    .replace(/\s+-/g, "-") // delete space before and after - and replace with just -
    .replace(/-\s+/g, "-") // delete space before and after - and replace with just -
}

export const replaceSpecialCharacters = (str) => {
  // replace all œ with oe and all ’ with '
  return str
    .replace(/’/g, "'")
    .replace(/œ/g, "oe")
    .replace(/‘/g, "'")
    .replace(/\s+/g, " ") // delete multiple spaces
    .replace(/\u2028/g, "") // delete \u2028 &#x2028; (unicode character)
    .replace(/\u2026/g, "...") // replace \u2026 &#x2026; (unicode character)
}

export const ignoreAccentsPunctuation = (text, ignoreCase = true) => {
  if (!text) return ""
  let newText = text
  if (ignoreCase) {
    newText = newText?.toLowerCase()
  }
  newText = newText
    .replace(/[àáâ]/g, "a")
    .replace(/[ÀÁÂ]/g, "A")
    .replace(/[èéëê]/g, "e")
    .replace(/[ÈÉËÊ]/g, "E")
    .replace(/[îïí]/g, "i")
    .replace(/[ÎÏÍ]/g, "I")
    .replace(/[ôöó]/g, "o")
    .replace(/[ÔÖÓ]/g, "O")
    .replace(/[ùûüú]/g, "u")
    .replace(/[ÙÛÜÚ]/g, "U")
    .replace(/[ç]/g, "c")
    .replace(/[Ç]/g, "C")
    .replace(/[ñ]/g, "n")
    .replace(/[Ñ]/g, "N")
    .replace(/[-]/g, " ") // replace hyphen with space
    .replace(/\u0769/g, "e") // e\u0769
  return newText
}

export const normalizeWord = (word = "") => {
  return word
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[.,!¡¿?()$]/g, "")
    .replace(/\s+/g, " ")
    .replace(/’/g, "'")
    .trim()
}

export const normalizeWord2 = (word = "") => {
  return (
    word
      .toLowerCase()
      // .normalize("NFD")
      // .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,!¡¿?]/g, "")
      .replace(/\s+/g, " ")
      .trim()
  )
}

export const ignoreAccents = (word = "") => {
  return word
    .replace(/[.,!¡¿?()$]/g, "")
    .replace(/\s+/g, " ")
    .replace(/’/g, "'")
    .trim()
}

export const formatWordToSearch = (word, languageId) => {
  let parseWord = parseText(normalizeWord2(word))
  // remove first - from word
  if (parseWord[0] === "-") {
    parseWord = parseWord?.slice(1).trim()
    // if word include -, check if before and after - are the same
    if (parseWord.includes("-")) {
      const [before, after] = parseWord.split("-")
      if (before.trim() === after.trim()) {
        parseWord = before.trim()
      }
    }
  }
  // remove all ( ) from word
  parseWord = parseWord.replace(/[()]/g, "")
  if (languageId !== LANGUAGES_NAME.SPANISH) {
    return commomWords(languageId, parseWord.trim())
  }
  return commomWords(languageId, parseWord.trim()).replace(/'/g, "")
}

// remove from commom words like The or A
export const commomWords = (languageId, text) => {
  const _text = text.toLowerCase()
  const commomEnglish = ["the ", "a ", "an ", "to "]
  const commomnFrench = [
    "le ",
    "la ",
    "les ",
    "l' ",
    "un ",
    "une ",
    "des ",
    "l'",
    "du ",
    "de l'",
  ]
  const commomSpanish = [
    "el ",
    "la ",
    "los ",
    "las ",
    "un ",
    "una ",
    "unos ",
    "unas ",
  ]

  switch (languageId) {
    case LANGUAGES_NAME.SPANISH:
      // if _text starts with one of the common words, return text without them
      for (const c in commomSpanish) {
        if (_text.startsWith(commomSpanish[c])) {
          return text.replace(commomSpanish[c], "").trim()
        }
      }
      break
    case LANGUAGES_NAME.FRENCH:
      for (const c in commomnFrench) {
        if (_text.startsWith(commomnFrench[c])) {
          return text.replace(commomnFrench[c], "").trim()
        }
      }
      break
    case LANGUAGES_NAME.ENGLISH:
      for (const c in commomEnglish) {
        if (_text.startsWith(commomEnglish[c])) {
          return text.replace(commomEnglish[c], "").trim()
        }
      }
      break
  }
  return text
}

export const escapeControlCharacters = (jsonString) => {
  // eslint-disable-next-line no-control-regex
  return jsonString.replace(/[\u0000-\u001F\u007F-\u009F]/g, function (match) {
    return "\\u" + ("0000" + match.charCodeAt(0).toString(16)).slice(-4)
  })
}
